import { nanoid } from "nanoid";

type TEnvironment = "development" | "qa" | "production";

interface IConfig {
  apiUrl: string;
  deviceUuid: string;
  environment: string;
  mixpanelToken: string;
  sentryDSN?: string;
  version?: string;
}

export const config: IConfig = ((environment: TEnvironment) => ({
  apiUrl: (() => {
    if (process.env.REACT_APP_API_URL) {
      return process.env.REACT_APP_API_URL;
    }

    switch (environment) {
      case "development":
        return "http://127.0.0.1:10000/api";

      case "qa":
        return "https://api.qa.yoney.ru/api";

      case "production":
        return "https://api.yoney.ru/api";

      default:
        throw new Error();
    }
  })(),
  deviceUuid: (() => {
    let deviceUuid = localStorage.getItem(`@yoney/${environment}/deviceUuid`);

    if (null === deviceUuid) {
      deviceUuid = nanoid();
      localStorage.setItem(`@yoney/${environment}/deviceUuid`, deviceUuid);
    }

    return deviceUuid;
  })(),
  environment,
  mixpanelToken: process.env.REACT_APP_MIXPANEL_TOKEN || "",
  sentryDSN: process.env.REACT_APP_SENTRY_DSN || "",
  version: "0.1.0",
}))(process.env.NODE_ENV as TEnvironment);
